module.exports = __webpack_public_path__ + "img/download.2a3b6f90.svg";